define('views/parts/form/choices/choice-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // templates
    'text!templates/parts/form/choices/choice-item.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // templates
    TChoiceItem
) {

    /**
     * Creates an input checkbox (default) or radio button with an inline label
     * and provides two-way binding via Epoxy.
     *
     * @param  {Boolean} radio default to false.
     * @param  {string} attribute of the model.
     * @param  {string} name of the input element (default to the attribute).
     * @param  {Array} choices the array of object defining "label" and "value".
     */
    var VChoiceItem = Backbone.View.extend({
        template: TChoiceItem,

        regions: {
            choice: ".choice-item",
        },
        initialize: function(opt) {
            var options = this.options = opt;

            this.listenTo(this.model, 'change:' + options.attribute, this.setActive);

        },
        render: function() {

            var $html = Backbone.$(Mustache.render(this.template,
                Mustache.getContext(this.options, this.options.namespace)));
            this.$el.replaceWith($html);
            this.setElement($html);

            this.generateZones();

            this.setActive();

            return this;
        },

        getValue: function() {
            return this.model.get(this.options.attribute);
        },

        setValue: function(value, options) {
            this.model.set(this.options.attribute, value, options);
        },

        // active class is only for bootstrap btn-group style
        setActive: function() {
            if (!this.options.styleButton) return;
            this.$el.toggleClass('active', this.getValue() === this.options.choice.value);
        },

    });

    return VChoiceItem;
});

